import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class ItemGuide {
    transformMatrixL: string;

    transformMatrixR: string;

    transformMatrixT: string;

    transformMatrixB: string;

    lineL: SVGElement;

    lineR: SVGElement;

    lineT: SVGElement;

    lineB: SVGElement;

    distanceLineL: SVGElement;

    distanceLineR: SVGElement;

    distanceLineT: SVGElement;

    distanceLineB: SVGElement;

    differenceLineL: SVGElement;

    differenceLineR: SVGElement;

    differenceLineT: SVGElement;

    differenceLineB: SVGElement;

    distanceTextLeft: SVGElement;

    distanceTextRight: SVGElement;

    distanceTextTop: SVGElement;

    distanceTextBottom: SVGElement;

    distTop: any;

    distRight: any;

    distBottom: any;

    distLeft: any;

    private readonly distanceInputList: HTMLInputElement[] = [];

    public spt: SVGSprite;

    viewObj: Element;

    x: number;

    y: number;

    transformMatrix: string;

    _width: number;

    get width() { return this._width; }

    set width(val) {
      this._width = Math.round(val);
    }

    _height: number;

    get height(): number { return this._height; }

    set height(val: number) {
      this._height = Math.round(val);
    }

    /**
     * コンストラクタ
     */
    constructor(container: Element) {
      this.distTop = null;
      this.distRight = null;
      this.distBottom = null;
      this.distLeft = null;
      this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.viewObj.id = 'itemGuide';

      // 各ラインの作成 ※Rectで作成すると、アイテムが選択できなくなるので、ラインで代用
      this.lineL = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.lineL.setAttribute('stroke', '#8D7E6F');
      this.lineL.setAttribute('stroke-width', '1');
      this.lineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.lineL.setAttribute('id', 'lineL');
      this.viewObj.appendChild(this.lineL);

      this.lineR = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.lineR.setAttribute('stroke', '#8D7E6F');
      this.lineR.setAttribute('stroke-width', '1');
      this.lineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.lineR.setAttribute('id', 'lineR');
      this.viewObj.appendChild(this.lineR);

      this.lineT = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.lineT.setAttribute('stroke', '#8D7E6F');
      this.lineT.setAttribute('stroke-width', '1');
      this.lineT.setAttribute('stroke-linecap', 'square');
      this.lineT.setAttribute('stroke-linejoin', 'miter');

      this.lineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.lineT.setAttribute('id', 'lineT');
      this.viewObj.appendChild(this.lineT);

      this.lineB = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.lineB.setAttribute('stroke', '#8D7E6F');
      this.lineB.setAttribute('stroke-width', '1');
      this.lineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.lineB.setAttribute('id', 'lineB');
      this.viewObj.appendChild(this.lineB);

      this.distanceLineL = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.distanceLineL.setAttribute('stroke', '#3598DC');
      this.distanceLineL.setAttribute('stroke-width', '1');
      this.distanceLineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.distanceLineL.setAttribute('id', 'distanceLineL');
      this.distanceLineL.setAttribute('transform', 'matrix( 1,0,0,1,6.5,25)');
      this.viewObj.appendChild(this.distanceLineL);

      this.distanceLineR = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.distanceLineR.setAttribute('stroke', '#3598DC');
      this.distanceLineR.setAttribute('stroke-width', '1');
      this.distanceLineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.distanceLineR.setAttribute('id', 'distanceLineR');
      this.distanceLineR.setAttribute('transform', 'matrix( 1,0,0,1,0,0)');
      this.viewObj.appendChild(this.distanceLineR);

      this.distanceLineT = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.distanceLineT.setAttribute('stroke', '#3598DC');
      this.distanceLineT.setAttribute('stroke-width', '1');
      this.distanceLineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.distanceLineT.setAttribute('id', 'distanceLineT');
      this.distanceLineT.setAttribute('transform', 'matrix( 1,0,0,1,0,0)');
      this.viewObj.appendChild(this.distanceLineT);

      this.distanceLineB = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.distanceLineB.setAttribute('stroke', '#3598DC');
      this.distanceLineB.setAttribute('stroke-width', '1');
      this.distanceLineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
      this.distanceLineB.setAttribute('id', 'distanceLineB');
      this.distanceLineB.setAttribute('transform', 'matrix( 1,0,0,1,0,0)');
      this.viewObj.appendChild(this.distanceLineB);

      this.differenceLineT = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      this.differenceLineT.setAttribute('stroke', '#2d2d2e');
      this.differenceLineT.setAttribute('stroke-width', '1');
      this.differenceLineT.setAttribute('stroke-dasharray', '4');
      this.differenceLineT.setAttribute('id', 'differenceLineT');
      this.viewObj.appendChild(this.differenceLineT);

      this.differenceLineR = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      this.differenceLineR.setAttribute('stroke', '#2d2d2e');
      this.differenceLineR.setAttribute('stroke-width', '1');
      this.differenceLineR.setAttribute('stroke-dasharray', '4');
      this.differenceLineR.setAttribute('id', 'differenceLineR');
      this.viewObj.appendChild(this.differenceLineR);

      this.differenceLineB = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      this.differenceLineB.setAttribute('stroke', '#2d2d2e');
      this.differenceLineB.setAttribute('stroke-width', '1');
      this.differenceLineB.setAttribute('stroke-dasharray', '4');
      this.differenceLineB.setAttribute('id', 'differenceLineB');
      this.viewObj.appendChild(this.differenceLineB);

      this.differenceLineL = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      this.differenceLineL.setAttribute('stroke', '#2d2d2e');
      this.differenceLineL.setAttribute('stroke-width', '1');
      this.differenceLineL.setAttribute('stroke-dasharray', '4');
      this.differenceLineL.setAttribute('id', 'differenceLineL');
      this.viewObj.appendChild(this.differenceLineL);

      this.distanceTextTop = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.distanceTextTop.setAttribute('height', '20');
      this.distanceTextTop.setAttribute('width', '50');
      const inpT = document.createElement('input');
      inpT.setAttribute('type', 'text');
      inpT.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
      this.distanceTextTop.appendChild(inpT);
      this.distanceTextTop.setAttribute('id', 'distanceTextTop');
      this.distanceTextTop.setAttribute('class', 'distanceText');
      this.viewObj.appendChild(this.distanceTextTop);
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // inpT.setAttribute("style", "position: fixed !important;");
        inpT.addEventListener('touchstart', (e: TouchEvent) => {
          (<HTMLInputElement>e.currentTarget).focus();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }, { passive: false });
      } else {
        inpT.addEventListener('mousedown', (e: MouseEvent) => {
          e.stopPropagation();
        });
      }
      inpT.addEventListener('keyup', ItemGuide.changeDistance);
      this.distanceInputList.push(inpT);

      this.distanceTextRight = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.distanceTextRight.setAttribute('height', '20');
      this.distanceTextRight.setAttribute('width', '50');
      const inpR = document.createElement('input');
      inpR.setAttribute('type', 'text');
      inpR.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
      this.distanceTextRight.appendChild(inpR);
      this.distanceTextRight.setAttribute('id', 'distanceTextRight');
      this.distanceTextRight.setAttribute('class', 'distanceText');
      this.viewObj.appendChild(this.distanceTextRight);
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // inpR.setAttribute("style", "position: fixed !important;");
        inpR.addEventListener('touchstart', (e: TouchEvent) => {
          (<HTMLInputElement>e.currentTarget).focus();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }, { passive: false });
      } else {
        inpR.addEventListener('mousedown', (e: MouseEvent) => {
          e.stopPropagation();
        });
      }
      inpR.addEventListener('keyup', ItemGuide.changeDistance);
      this.distanceInputList.push(inpR);

      this.distanceTextBottom = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.distanceTextBottom.setAttribute('height', '20');
      this.distanceTextBottom.setAttribute('width', '50');
      const inpB = document.createElement('input');
      inpB.setAttribute('type', 'text');
      inpB.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
      this.distanceTextBottom.appendChild(inpB);
      this.distanceTextBottom.setAttribute('id', 'distanceTextBottom');
      this.distanceTextBottom.setAttribute('class', 'distanceText');
      this.viewObj.appendChild(this.distanceTextBottom);
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // inpB.setAttribute("style", "position: fixed !important;");
        inpB.addEventListener('touchstart', (e: TouchEvent) => {
          (<HTMLInputElement>e.currentTarget).focus();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }, { passive: false });
      } else {
        inpB.addEventListener('mousedown', (e: MouseEvent) => {
          e.stopPropagation();
        });
      }
      inpB.addEventListener('keyup', ItemGuide.changeDistance);
      this.distanceInputList.push(inpB);

      this.distanceTextLeft = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.distanceTextLeft.setAttribute('height', '20');
      this.distanceTextLeft.setAttribute('width', '50');
      const inpL = document.createElement('input');
      inpL.setAttribute('type', 'text');
      inpL.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
      this.distanceTextLeft.appendChild(inpL);
      this.distanceTextLeft.setAttribute('id', 'distanceTextLeft');
      this.distanceTextLeft.setAttribute('class', 'distanceText');
      this.viewObj.appendChild(this.distanceTextLeft);
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // inpL.setAttribute("style", "position: fixed !important;");
        inpL.addEventListener('touchstart', (e: TouchEvent) => {
          (<HTMLInputElement>e.currentTarget).focus();
          e.stopImmediatePropagation();
          e.stopPropagation();
        }, { passive: false });
      } else {
        inpL.addEventListener('mousedown', (e: MouseEvent) => {
          e.stopPropagation();
        });
      }
      inpL.addEventListener('keyup', ItemGuide.changeDistance);
      this.distanceInputList.push(inpL);

      this.spt = new SVGSprite(this.viewObj);
      container.appendChild(this.viewObj);
      this.show();
    }

    /**
     * リサイズ
     */
    resize(rect: { width: number, height: number }) {
      // 保持
      this.width = rect.width;
      this.height = rect.height;

      this.lineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, rect.height)));
      this.transformMatrixL = `matrix(1,0,0,1,${-rect.width / 2},${-rect.height / 2})`;
      this.lineL.setAttribute('transform', this.transformMatrixL);

      this.lineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, rect.height)));
      this.transformMatrixR = `matrix(1,0,0,1,${rect.width / 2},${-rect.height / 2})`;
      this.lineR.setAttribute('transform', this.transformMatrixR);

      this.lineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(rect.width, 0)));
      this.transformMatrixT = `matrix(1,0,0,1,${-rect.width / 2},${-rect.height / 2})`;
      this.lineT.setAttribute('transform', this.transformMatrixT);

      this.lineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(rect.width, 0)));
      this.transformMatrixB = `matrix(1,0,0,1,${-rect.width / 2},${rect.height / 2})`;
      this.lineB.setAttribute('transform', this.transformMatrixB);
    }

    updateDistanceLine(top, right, bottom, left) {
      this.distTop = top;
      this.distRight = right;
      this.distBottom = bottom;
      this.distLeft = left;

      this.hideAllDifferenceLine();
      this.distanceLineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, this.distTop.startPoint.y), new marietta.core.Point(0, this.distTop.point.y)));
      this.transformMatrixT = 'matrix(1,0,0,1,0,0)';
      this.distanceLineT.setAttribute('transform', this.transformMatrixT);
      if (this.distTop.startPoint.x !== 0 && this.distTop.diffLine.showDiffLine) {
        const newPoint = this.distTop.diffLine.diffLinePoint.clone();
        newPoint.x = 0;
        ItemGuide.showDifference(this.distTop.diffLine.diffLinePoint, newPoint, this.differenceLineT);
      }

      this.distanceLineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.distRight.startPoint.x, 0), new marietta.core.Point(this.distRight.point.x, 0)));
      this.transformMatrixR = 'matrix(1,0,0,1,0,0)';
      this.distanceLineR.setAttribute('transform', this.transformMatrixR);
      if (this.distRight.startPoint.y !== 0 && this.distRight.diffLine.showDiffLine) {
        const newPoint = this.distRight.diffLine.diffLinePoint.clone();
        newPoint.y = 0;
        ItemGuide.showDifference(this.distRight.diffLine.diffLinePoint, newPoint, this.differenceLineR);
      }

      this.distanceLineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, this.distBottom.startPoint.y), new marietta.core.Point(0, this.distBottom.point.y)));
      this.transformMatrixB = 'matrix(1,0,0,1,0,0)';
      this.distanceLineB.setAttribute('transform', this.transformMatrixB);
      if (this.distBottom.startPoint.x !== 0 && this.distBottom.diffLine.showDiffLine) {
        const newPoint = this.distBottom.diffLine.diffLinePoint.clone();
        newPoint.x = 0;
        ItemGuide.showDifference(this.distBottom.diffLine.diffLinePoint, newPoint, this.differenceLineB);
      }

      this.distanceLineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(this.distLeft.startPoint.x, 0), new marietta.core.Point(this.distLeft.point.x, 0)));
      this.transformMatrixL = 'matrix(1,0,0,1,0,0)';
      this.distanceLineL.setAttribute('transform', this.transformMatrixL);
      if (this.distLeft.startPoint.y !== 0 && this.distLeft.diffLine.showDiffLine) {
        const newPoint = this.distLeft.diffLine.diffLinePoint.clone();
        newPoint.y = 0;
        ItemGuide.showDifference(this.distLeft.diffLine.diffLinePoint, newPoint, this.differenceLineL);
      }
      this.upadateDistanceText();
    }

    /**
     * ガイドラインテキスト更新
     */
    upadateDistanceText() {
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;

      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1.5 / root.scaleX;

      if (!this.distTop || !this.distRight || !this.distBottom || !this.distLeft) return;
      const d = 20 / marietta.webcad.WebCADGlobal.scaleSize;
      const rotation = marietta.WebCADGlobal.itemManager.currentItem ? marietta.WebCADGlobal.itemManager.currentItem.itemInfo.rotation : null;
      let transform = `matrix(1,0,0,1,${-50},${marietta.core.Point.interpolate(new marietta.core.Point(0, this.distTop.startPoint.y), new marietta.core.Point(0, this.distTop.point.y), 0.5).y - 25 - (((rotation >= 0 && rotation <= 45) || rotation >= 315) ? d : 0)})`;
      if (!ua.isPC) {
        transform = `matrix(${sc},0,0,${sc},${-50 * sc},${this.distTop.startPoint.y - (60 * sc)})`;
      }

      this.distanceTextTop.setAttribute('transform', transform);
      (<HTMLInputElement> this.distanceTextTop.children[0]).value = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(this.distTop.distance)).toString();

      transform = `matrix(1,0,0,1,${marietta.core.Point.interpolate(new marietta.core.Point(this.distRight.startPoint.x, 0), new marietta.core.Point(this.distRight.point.x, 0), 0.5).x + 5 + ((rotation > 45 && rotation <= 135) ? d : 0)},${ua.isPC ? -25 : -45})`;
      if (!ua.isPC) {
        transform = `matrix(${sc},0,0,${sc},${this.distRight.startPoint.x + (55 * sc)},${-25 * sc})`;
      }
      this.distanceTextRight.setAttribute('transform', transform);
      (<HTMLInputElement> this.distanceTextRight.children[0]).value = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(this.distRight.distance)).toString();

      transform = `matrix(1,0,0,1,${-50},${marietta.core.Point.interpolate(new marietta.core.Point(0, this.distBottom.startPoint.y), new marietta.core.Point(0, this.distBottom.point.y), 0.5).y + 5 + ((rotation > 135 && rotation <= 225) ? d : 0)})`;
      if (!ua.isPC) {
        transform = `matrix(${sc},0,0,${sc},${-50 * sc},${this.distBottom.startPoint.y + (60 * sc)})`;
      }
      this.distanceTextBottom.setAttribute('transform', transform);
      (<HTMLInputElement> this.distanceTextBottom.children[0]).value = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(this.distBottom.distance)).toString();

      transform = `matrix(1,0,0,1,${marietta.core.Point.interpolate(new marietta.core.Point(this.distLeft.startPoint.x, 0), new marietta.core.Point(this.distLeft.point.x, 0), 0.5).x - 50 - ((rotation > 225 && rotation < 315) ? d : 0)},${ua.isPC ? -25 : -45})`;
      if (!ua.isPC) {
        transform = `matrix(${sc},0,0,${sc},${this.distLeft.startPoint.x - (100 * sc)},${-25 * sc})`;
      }
      this.distanceTextLeft.setAttribute('transform', transform);
      (<HTMLInputElement> this.distanceTextLeft.children[0]).value = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(this.distLeft.distance)).toString();
    }

    static showDifference(start: marietta.core.Point, end: marietta.core.Point, diffLine) {
      diffLine.setAttribute('x1', start.x.toString());
      diffLine.setAttribute('x2', end.x.toString());
      diffLine.setAttribute('y1', start.y.toString());
      diffLine.setAttribute('y2', end.y.toString());

      const _diffLine = diffLine;
      _diffLine.style.display = 'block';
    }

    hideAllDifferenceLine() {
      this.differenceLineT.style.display = 'none';
      this.differenceLineR.style.display = 'none';
      this.differenceLineB.style.display = 'none';
      this.differenceLineL.style.display = 'none';
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTranslate();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTranslate();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTranslate();
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示OFF
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }

    /**
     * 寸法入力を編集不可にする
     */
    public disableInputs(): void {
      this.distanceInputList.forEach((input) => {
        input.disabled = true;
      });
    }

    /**
     * 寸法入力を編集可能にする
     */
    public enableInputs(): void {
      this.distanceInputList.forEach((input) => {
        input.disabled = false;
      });
    }

    /**
     * Translateのアップデート
     */
    updateTranslate() {
      this.transformMatrix = `matrix(1,0,0,1,${this.x},${this.y})`;
      this.viewObj.setAttribute('transform', this.transformMatrix);
    }

    static changeDistance(event: KeyboardEvent) {
      // 数値と小数点以下の桁数の検証
      // 小数点以下2桁に制限
      // 最大：100,000
      const validate = (e) => {
        const t = e.value;
        const ex = /^[0-9]+\.?[0-9]*$/;
        if (ex.test(t) === false) {
          e.value = t.substring(0, t.length - 1);
        } else {
          e.value = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t;
          const x = parseFloat(t);
          if (Number.isNaN(x) || x < 0 || x > 100000) {
            e.value = t.substring(0, t.length - 1);
          }
        }
      };
      validate(event.currentTarget);
      const target = <HTMLInputElement>event.currentTarget;
      const dist = target.value;
      if (dist === '') {
        target.style.border = 'solid 2px red';
      } else if (Number.isNaN(parseFloat(dist)) || parseFloat(dist) < 0 || parseFloat(dist) > 100000) {
        target.style.border = 'solid 2px red';
      } else {
        target.style.border = 'solid 2px green';
      }
      if (event.keyCode === 13) {
        event.preventDefault();
        if (dist === '' || Number.isNaN(parseFloat(dist)) || parseFloat(dist) < 0 || parseFloat(dist) > 100000) {
          target.style.border = 'solid 2px red';
        } else {
          const newDistance = dist;
          const id = target.parentElement.getAttribute('id');
          if (marietta.webcad.WebCADGlobal.itemManager.itemController !== undefined) {
            marietta.webcad.WebCADGlobal.itemManager.itemController.moveItemWithInput(newDistance, id.substring(12, id.length), true);
          }
          target.style.border = 'solid 2px green';
        }
      }

      event.stopPropagation();
    }
}
